module.exports = __webpack_public_path__ + "src/assets/img/46.1aeb6078.svg";